import { render, staticRenderFns } from "./Etapa03.vue?vue&type=template&id=0c04d54b"
import script from "./Etapa03.vue?vue&type=script&lang=js"
export * from "./Etapa03.vue?vue&type=script&lang=js"
import style0 from "./Etapa03.vue?vue&type=style&index=0&id=0c04d54b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports